import { render } from "./UserTerms.vue?vue&type=template&id=6201ec6a"
const script = {}

import "./UserTerms.vue?vue&type=style&index=0&id=6201ec6a&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__